import { useState, useEffect } from 'react'
import Section from './_Section'
import ButtonEl from '../helpers/ctas/Button'
import Image from '../helpers/Image'
import TitleBlock from '../helpers/TitleBlock'
import { transformPaddingToTailwind } from '../../helpers/style'
import RatesCalloutWrapper from '../helpers/RatesCalloutWrapper'

function RatesCalloutBanner(props) {
  const [hasProducts, setHasProducts] = useState(false)
  const componentPadding = transformPaddingToTailwind(props.componentPadding, true)
  
  // Handle content alignment (left/center/right) from Component Configuration
  const alignment = props.contentAlignment?.toLowerCase() || 'center'
  const flexAlignClass = alignment === 'center' ? 'justify-center' : 'justify-start'
  const textAlignClass = alignment === 'center' ? 'text-center' : alignment === 'right' ? 'text-right' : 'text-left'
  
  // Prioritize Component Configuration images over Content images
  const mobileBgImage = props.mobileBackgroundImage || props.mobileImage
  const desktopBgImage = props.desktopBackgroundImage || props.desktopImage

  useEffect(() => {
    setHasProducts(props.products?.length > 0)
  }, props.products)

  return (
    <>
      <Section
        {...props}
        type="heroBanner"
        data-variant="withRatesCallout"
        sectionTitle={false}
        mobileBackgroundImage={mobileBgImage}
        desktopBackgroundImage={desktopBgImage}
        innerClass={`flex ${flexAlignClass} ${componentPadding.top} ${hasProducts ? componentPadding.mid : componentPadding.bottom}`}
      >
        <div className={`mx-6 max-w-3xl ${textAlignClass}`}>
          {(props.title || props.description) && <TitleBlock {...props} />}
          {props.ctaLinks && props.ctaLinks.length != 0 && (
            <div className={`flex ${flexAlignClass} max-lg:flex-wrap max-lg:space-y-6 space-x-6 mt-10`}>
              {props.ctaLinks.map((ctaLinkItem, i) => (
                <ButtonEl
                  key={i}
                  link={ctaLinkItem.link}
                  theme={ctaLinkItem.linkType.toLowerCase()}
                  icon={ctaLinkItem.linkIconClass}
                  position={ctaLinkItem.linkPosition}
                />
              ))}
            </div>
          )}
        </div>
      </Section>
      {props.products?.length && (
        <section
          data-type="embeddedRatesCallout"
          className={`${componentPadding.card} ${componentPadding.bottom} container mx-auto relative z-10`}
        >
          <RatesCalloutWrapper
            {...props}
            rate={props.products[0]}
            title={props.ratesCardTitle}
            description={props.ratesCardDescription}
            embedded="true"
            className="bg-white text-shadow-off"
          />
        </section>
      )}
    </>
  )
}

export default RatesCalloutBanner
